import React from 'react';
import { ExclamationTriangleIcon, ArrowPathIcon } from '@heroicons/react/24/outline';

const ErrorMessage = ({
    message,
    onRetry,
    size = 'medium',
    showIcon = true,
}) => {
    const sizeConfig = {
        small: { padding: '0.75rem', fontSize: '0.8rem', iconSize: 16 },
        medium: { padding: '1rem', fontSize: '0.85rem', iconSize: 20 },
        large: { padding: '1.5rem', fontSize: '0.95rem', iconSize: 24 },
    };

    const config = sizeConfig[size] || sizeConfig.medium;

    return (
        <div
            style={{
                ...styles.container,
                padding: config.padding,
            }}
            role="alert"
        >
            <div style={styles.content}>
                {showIcon && (
                    <ExclamationTriangleIcon
                        style={{
                            width: config.iconSize,
                            height: config.iconSize,
                            color: '#FF3B30',
                            flexShrink: 0,
                        }}
                        aria-hidden="true"
                    />
                )}
                <span style={{ ...styles.message, fontSize: config.fontSize }}>
                    {message}
                </span>
            </div>
            {onRetry && (
                <button
                    onClick={onRetry}
                    style={styles.retryButton}
                    aria-label="Retry"
                >
                    <ArrowPathIcon style={{ width: 14, height: 14 }} aria-hidden="true" />
                    <span>Retry</span>
                </button>
            )}
        </div>
    );
};

const styles = {
    container: {
        backgroundColor: 'rgba(255, 59, 48, 0.06)',
        borderRadius: '12px',
        border: '1px solid rgba(255, 59, 48, 0.12)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px',
    },
    content: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    message: {
        color: '#1D1D1F',
        fontWeight: '500',
    },
    retryButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        padding: '6px 14px',
        backgroundColor: 'rgba(255, 59, 48, 0.1)',
        color: '#FF3B30',
        border: 'none',
        borderRadius: '8px',
        fontSize: '0.8rem',
        fontWeight: '600',
        cursor: 'pointer',
    },
};

export default ErrorMessage;
